// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";

export const getWebsite = (state: ApplicationState) => {
    return state.context.website;
};

export const getWebsiteName = (state: ApplicationState) => {
    return getWebsite(state).name;
};

export const getDisplayProductPricesPolicy = (state: ApplicationState) => {
    return getSettingsCollection(state).bunzlSettings?.displayProductPricesPolicy;
};
